var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal",
      "height": "auto",
      "name": "ugcRepositionWarningModal",
      "width": "92%",
      "clickToClose": false
    },
    on: {
      "beforeOpen": _vm.setSizesInModal
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "backDisabled": true,
      "buttonText": true,
      "includeClose": false,
      "headerImg": true,
      "includeBack": false
    }
  }), _c('CustomContainer', {
    staticClass: "new-modal-main-views-wrapper",
    attrs: {
      "elementType": "section"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-error-icon",
    attrs: {
      "elementType": "div"
    }
  }, [_vm._v(" ! ")]), _c('CustomText', {
    attrs: {
      "customClass": "new-modal-title",
      "elementType": "h2",
      "keyTranslation": "repositionHeader"
    }
  }), _c('CustomText', [_c('template', {
    slot: "child"
  }, [_c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v(_vm._s(this.translations['repositionSubHeader']) + " ("), _c('span', [_vm._v(_vm._s(this.contentProps.prevUGCSize))]), _vm._v(")\n              " + _vm._s(this.translations['repositionSubHeader2']) + " ("), _c('span', [_vm._v(_vm._s(this.contentProps.newUGCSize))]), _vm._v(")\n              " + _vm._s(this.translations['repositionSubHeader3']) + "\n              ")])])], 2)], 1)], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded primary",
      "type": "button",
      "keyTranslation": "repositionReposition"
    },
    on: {
      "click": _vm.startRepositionFlow
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }